import { render, staticRenderFns } from "./ProjFormDrawer.vue?vue&type=template&id=0c62a53b&scoped=true"
import script from "./ProjFormDrawer.vue?vue&type=script&lang=js"
export * from "./ProjFormDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProjFormDrawer.vue?vue&type=style&index=0&id=0c62a53b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62a53b",
  null
  
)

export default component.exports